export default __webpack_public_path__ + "static/media/ci.81367758.png";